<template>
    <div class="elegant-img__wrapper" :loading="imgLoading ? 'yes' : 'no'">
        <img :src="imgSrc" alt="项目图片" />
    </div>
</template>

<script>
import limitState from './limiter-state'
import { downloadUrl } from "@/utils";
import projectHome from '@/xgzdService/projectHome-service'
export default {
    props: {
        prjId: { type: String },
        prjName: { type: String }
    },
    data() {
        return {
            imgLoading: true,
            defaultImage: require('@/views/workbench/img/defaultImage.jpg'),
            imgSrc: ""
        }
    },
    created() {
        this.loadImage()
    },
    methods: {
        async loadImage() {
            this.imgLoading = true
            const res = await limitState.getAsyncRequest(this.generateImagePromise).catch(
                err => {
                    console.warn(`加载项目[${this.prjName}]图片失败,将赋予默认图片, 原因: ${err?.message || err}`)
                    return this.defaultImage
                }
            )
            this.imgSrc = res
            this.imgLoading = false
        },
        generateImagePromise() {
            const { prjId, defaultImage } = this
            return new Promise(async function (resolve, reject) {
                const image = new Image()
                const errorHandler = (msg) => {
                    reject(msg)
                }
                if (!prjId) {
                    errorHandler('缺少项目ID')
                    return
                }
                const res = await projectHome.getFileIdList(prjId, 0)
                const picId = res?.data?.[0]?.fileId
                if (!picId) {
                    errorHandler('缺少图片ID')
                    return
                }
                const src = downloadUrl(prjId, picId)
                image.onload = (event) => {
                    resolve(image.src)
                }
                image.onerror = (event) => {
                    resolve(defaultImage)
                }
                image.src = src
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.elegant-img__wrapper {
    height: 100%;
    width: 100%;
    position: relative;

    @keyframes loading {
        to {
            background-position-x: -20%;
        }
    }

    img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    &[loading="yes"] {
        &::after {
            content: '';
            position: absolute;
            left: 0px;
            top: 0px;
            height: 100%;
            width: 100%;
            z-index: 2;
            background: linear-gradient(100deg,
                    rgba(255, 255, 255, 0) 40%,
                    rgba(255, 255, 255, 0.5) 50%,
                    rgba(255, 255, 255, 0) 60%) #ededed;
            background-size: 200% 100%;
            background-position-x: 120%;
            animation: 1s loading ease-in-out infinite;
        }
    }
}
</style>